export const translations = {
  fr: {
    // Navigation & Sidebar
    dashboard: "Tableau de bord",
    newCreation: "Nouvelle Création",
    adGenerator: "Générateur Pub",
    myProjects: "Mes Projets",
    logout: "Déconnexion",
    login: "Se connecter",
    signup: "S'inscrire",
    
    // Mobile Nav
    home: "Accueil",
    create: "Créer",
    pub: "Pub",
    projects: "Projets",
    profile: "Profil",
    
    // Common
    tokens: "jetons",
    tokensAvailable: "jetons disponibles",
    
    // Landing Page
    startAdventure: "Commencer l'aventure",
    viewDemo: "Voir la démo",
    tryNow: "Essayer maintenant",
    heroTitle: "Créez l'extraordinaire.\nEn quelques secondes.",
    heroSubtitle: "Générez des vidéos publicitaires et du contenu viral avec une fluidité inégalée.",
    demoBadge: "DÉMO INTERACTIVE",
    howItWorks: "Comment ça marche ?",
    threeSteps: "Trois étapes simples pour créer des vidéos exceptionnelles",
    step1Title: "Décrivez votre vision",
    step1Desc: "Expliquez simplement ce que vous voulez créer. Notre IA comprend le contexte et vos intentions.",
    step2Title: "L'IA génère",
    step2Desc: "VEO3 analyse votre demande et crée une vidéo 8K haute fidélité en quelques secondes.",
    step3Title: "Téléchargez",
    step3Desc: "Votre vidéo est prête. Téléchargez-la instantanément et partagez-la sur vos plateformes.",
    globalTitle: "Parlez toutes les langues.",
    globalDesc: "Générez vos contenus en Français et en Anglais. Touchez le monde entier sans la moindre barrière.",
    globalBadge: "GLOBAL",
    limitedOffer: "OFFRE LIMITÉE",
    boostCreativity: "Boostez votre créativité.",
    offerTokens: "pour 20 + 5 jetons offerts",
    getOffer: "Profiter de l'offre",
    formatsTitle: "Tous vos formats préférés.",
    formatsDesc: "Adapté pour TikTok, Reels, YouTube et plus encore.",
    verticalFormat: "Vertical",
    tiktokReels: "TikTok & Reels",
    landscapeFormat: "Paysage",
    youtubeWeb: "YouTube & Web",
    demoInput: "Une publicité pour une montre de luxe...",

    // Dashboard
    totalVideos: "Vidéos Totales",
    creativeStudio: "Studio Créatif",
    generateVideo: "Générer une vidéo",
    adGeneratorDesc: "Vidéo produit pro",
    recentProjects: "Projets récents",
    fullHistory: "Historique complet",
    noVideos: "Aucune vidéo pour le moment.",
    rechargeTokens: "Recharger vos jetons",
    rechargeSubtitle: "Propulsez vos projets avec nos packs haute performance",
    popular: "Populaire",
    priorityGen: "Génération priorité",
    qualityHD: "Qualité Ultra HD",
    expertSupport: "Support Expert",
    processing: "Traitement...",
    choosePackage: "Choisir ce pack",
    close: "Fermer",
    
    // Projects
    libraryDesc: "Bibliothèque haute performance de vos créations AI",
    viewAll: "Tout voir",
    landscape: "Paysage",
    portrait: "Portrait",
    merge: "Fusionner",
    cancel: "Annuler",
    loadingLibrary: "Chargement de votre bibliothèque...",
    emptyLibrary: "Bibliothèque vide",
    emptyLibraryDesc: "Vos futures créations seront archivées automatiquement ici.",
    createFirstVideo: "Créer ma première vidéo",
    viewAllText: "Voir tout",
    hideText: "Masquer",
    viewDownload: "Voir / Télécharger",
    mergeSequences: "Fusionner les séquences",
    organizeOrder: "Organisez l'ordre de vos",
    videos: "vidéos",
    untitled: "Sans titre",
    startMerge: "Lancer la fusion",
    merging: "Fusion en cours",
    fullPrompt: "Prompt complet",
    mergeMode: "Mode Fusion",
    mergeInstructions: "Sélectionnez vos vidéos en cochant les cases pour commencer la fusion.",
    understood: "Compris",
    
    // CreateVideo
    welcomeStudio: "Bienvenue dans le Studio Créatif. 👋 \n\nJe suis prêt à donner vie à vos idées. Décrivez votre concept, envoyez une photo de référence si vous le souhaitez, et je génère votre vidéo.",
    studioEngine: "Studio Creative Engine",
    optimizedBy: "Optimisé par VEO3",
    clearHistory: "Effacer l'historique",
    confirm: "Confirmer",
    save: "Enregistrer",
    generateSequel: "Générer une suite",
    mergeOrder: "Ordre de fusion :",
    scene: "Scène",
    selectTwoVideos: "Sélectionnez au moins 2 vidéos",
    landscapeRatio: "Paysage (16:9)",
    portraitRatio: "Portrait (9:16)",
    optimizing: "Optimisation...",
    improvePrompt: "Améliorer le prompt",
    highFidelity: "8s High Fidelity",
    processingImage: "Traitement image...",
    explainVision: "Expliquez votre vision...",
    propelProjects: "Propulsez vos projets",
    limitlessCreativity: "Plus de jetons pour une créativité sans limites",
    recommended: "Recommandé",
    choose: "Choisir",
    clearHistoryTitle: "Effacer l'historique ?",
    clearHistoryConfirm: "Voulez-vous vraiment supprimer l'historique de chat ?",
    clearHistoryNote: "Note : Ce chat est stocké localement et n'est visible sur aucun autre appareil.",
    delete: "Supprimer",
    cv_sequel_prefix: "Suite de la vidéo : ",
    cv_merge_title: "🎬 **Fusion de Séquences**\n\nOrganisez vos scènes avant la fusion finale.",
    cv_merge_canceled: "Fusion annulée.",
    cv_merge_confirmed: "Fusion confirmée. Traitement en cours...",
    cv_merge_prep: "Préparation de la fusion de {count} vidéos... (cela peut prendre du temps)",
    cv_finalizing: "Finalisation...",
    cv_merge_success: "Fusion terminée ! Voici le résultat des {count} vidéos.{saved}",
    cv_saved_project: " (Sauvegardé dans vos projets)",
    cv_merge_error_res: "Une erreur est survenue lors de la fusion des vidéos. Cette opération peut être gourmande en ressources.",
    cv_merge_failed: "La fusion a échoué.",
    cv_invalid_format: "Format invalide. JPG uniquement.",
    cv_upload_error: "Erreur upload image.",
    cv_optimize_title: "⚡ **Optimisation du prompt**\n\n📝 **Original :** {original}\n\n✨ **Amélioré :** {improved}\n\n(Le champ de saisie a été mis à jour)",
    cv_tokens_insufficient: "⚠️ Jetons insuffisants (10 requis pour la génération).",
    cv_confirm_gen: "Voulez-vous vraiment générer la vidéo pour ce prompt : \"{prompt}\" ?\n\nCoût de la génération : 10 jetons.",
    cv_conf_received: "Confirmation reçue. Génération en cours...",
    cv_success_gen: "Opération terminée avec succès. Voici votre création.",
    cv_critical_error: "Une erreur critique est survenue lors de la génération. Assurez-vous que votre prompt respecte les conditions suivantes : pas de contenu violent, sexuel, haineux,contenant des photos d'enfants, ou tout autre sujet sensible. Essayez de reformuler votre prompt en évitant ces thèmes.",
    cv_gen_canceled: "Génération annulée.",
    cv_offer_error: "Erreur offres.",

    // AdGenerator Chat
    ad_welcome: "Bonjour ! Je suis votre expert en publicité vidéo. (08 secondes pour le moment) 👋\n\nPour commencer, quel est le nom du produit que vous souhaitez mettre en avant ?",
    ad_bg_timeout: "Le traitement a pris trop de temps ou a échoué.",
    ad_bg_complete: "Génération terminée en arrière-plan.",
    ad_video_recovered: "Voici votre vidéo (récupérée) :",
    ad_offer_error: "Erreur chargement offres.",
    ad_step0_resp: "Noté. Quelle émotion ou envie souhaitez-vous susciter chez votre audience ? (ex: Luxe, Rapidité, Confort...)",
    ad_step1_resp: "Très bien. Quels sont les points clés ou fonctionnalités principales à mettre en avant ?",
    ad_step2_resp: "Parfait. Veuillez maintenant télécharger une image de votre produit en cliquant sur l'icône image ci-dessous.",
    ad_step3_error: "J'ai besoin d'une image pour continuer. Utilisez l'icône 🖼️ à gauche du champ de texte.",
    ad_step4_resp: "C'est noté. Dans quelle langue souhaitez-vous la publicité ?",
    ad_format_ask: "Quel format souhaitez-vous ? (Portrait pour TikTok/Reels, Paysage pour YouTube/Web)",
    ad_format_portrait: "Format Portrait (9:16)",
    ad_format_landscape: "Format Paysage (16:9)",
    ad_analyzing: "Analyse en cours... Je génère des concepts publicitaires optimisés pour votre produit.",
    ad_unspecified: "Non spécifié",
    ad_skip_price: "Ignorer le prix",
    ad_follow_steps: "Veuillez suivre les étapes de la conversation.",
    ad_img_sent: "Image envoyée",
    ad_img_received: "Image reçue ! Quel est le prix du produit (ou une gamme de prix) ?",
    ad_analysis_done: "Analyse terminée ! Voici 5 concepts publicitaires. Cliquez sur celui que vous préférez pour générer la vidéo.",
    ad_analysis_error: "Une erreur est survenue lors de l'analyse.",
    ad_tokens_insufficient: "⚠️ Jetons insuffisants (10 requis).",
    ad_confirm_concept: "Vous avez choisi le concept : \"{suggestion}\"\n\nConfirmez-vous la génération ? (Coût : 10 jetons)",
    ad_concept_validated: "Concept validé. Lancement de la production...",
    ad_downloading_img: "Excellent choix ! Téléchargement de l'image et lancement de la production...",
    ad_img_ready: "Image prête. Génération de la vidéo en cours...",
    ad_gen_success: "Vidéo générée avec succès !",
    ad_gen_another: "Souhaitez-vous générer une autre publicité ?",
    ad_gen_error: "Erreur lors de la génération de la vidéo.",
    ad_gen_canceled: "Génération annulée.",
    
    // AdGenerator
    adGenTitle: "Générateur Publicité",
    marketingAssistant: "Assistant Marketing IA",
    clearConversation: "Effacer la conversation",
    confirmTokens: "Confirmer (10 jetons)",
    newAd: "Nouvelle pub",
    selectConcept: "Sélectionnez un concept :",
    restart: "Recommencer",
    restartZero: "Recommencer à zéro",
    uploadImage: "Téléchargez une image...",
    writeResponse: "Écrivez votre réponse...",
    skip: "Ignorer",
    propelAds: "Propulsez vos publicités avec nos packs",
    
    // Auth & Footer
    accessExcellence: "Accédez à l'excellence technologique. Studio de création vidéo haute performance.",
    reset: "Réinitialiser",
    email: "Email",
    sendLink: "Envoyer le lien",
    backLogin: "Retour à la connexion",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    connecting: "Connexion...",
    noAccount: "Pas encore de compte ?",
    joinElite: "Rejoignez l'élite créative. Des vidéos professionnelles à la portée de votre imagination.",
    createAccount: "Créer un compte",
    fullName: "Nom complet",
    confirmEmail: "Confirmer Email",
    registering: "Inscription...",
    registerFree: "S'inscrire gratuitement",
    alreadyAccount: "Déjà un compte ?",
    footerDesc: "La solution ultime pour générer des vidéos publicitaires et virales grâce à l'intelligence artificielle.",
    product: "Produit",
    pricing: "Tarifs",
    features: "Fonctionnalités",
    showcase: "Showcase",
    legal: "Légal",
    legalMentions: "Mentions légales",
    privacyPolicy: "Politique de confidentialité",
    terms: "CGV",
    contact: "Contact",
    needHelp: "Besoin d'aide ?",
    rightsReserved: "Tous droits réservés."
  },
  en: {
    // Navigation & Sidebar
    dashboard: "Dashboard",
    newCreation: "New Creation",
    adGenerator: "Ad Generator",
    myProjects: "My Projects",
    logout: "Logout",
    login: "Login",
    signup: "Sign up",
    
    // Mobile Nav
    home: "Home",
    create: "Create",
    pub: "Ad",
    projects: "Projects",
    profile: "Profile",
    
    // Common
    tokens: "tokens",
    tokensAvailable: "tokens available",
    
    // Landing Page
    startAdventure: "Start the adventure",
    viewDemo: "View demo",
    tryNow: "Try now",
    heroTitle: "Create the extraordinary.\nIn seconds.",
    heroSubtitle: "Generate advertising videos and viral content with unmatched fluidity.",
    demoBadge: "INTERACTIVE DEMO",
    howItWorks: "How it works?",
    threeSteps: "Three simple steps to create exceptional videos",
    step1Title: "Describe your vision",
    step1Desc: "Simply explain what you want to create. Our AI understands context and your intentions.",
    step2Title: "AI generates",
    step2Desc: "VEO3 analyzes your request and creates a high-fidelity 8K video in seconds.",
    step3Title: "Download",
    step3Desc: "Your video is ready. Download it instantly and share it on your platforms.",
    globalTitle: "Speak all languages.",
    globalDesc: "Generate your content in French and English. Reach the whole world without any barrier.",
    globalBadge: "GLOBAL",
    limitedOffer: "LIMITED OFFER",
    boostCreativity: "Boost your creativity.",
    offerTokens: "for 20 + 5 free tokens",
    getOffer: "Get the offer",
    formatsTitle: "All your favorite formats.",
    formatsDesc: "Adapted for TikTok, Reels, YouTube and more.",
    verticalFormat: "Vertical",
    tiktokReels: "TikTok & Reels",
    landscapeFormat: "Landscape",
    youtubeWeb: "YouTube & Web",
    demoInput: "An advertisement for a luxury watch...",

    // Dashboard
    totalVideos: "Total Videos",
    creativeStudio: "Creative Studio",
    generateVideo: "Generate Video",
    adGeneratorDesc: "Pro Product Video",
    recentProjects: "Recent Projects",
    fullHistory: "Full History",
    noVideos: "No videos yet.",
    rechargeTokens: "Recharge Tokens",
    rechargeSubtitle: "Boost your projects with our high-performance packs",
    popular: "Popular",
    priorityGen: "Priority Generation",
    qualityHD: "Ultra HD Quality",
    expertSupport: "Expert Support",
    processing: "Processing...",
    choosePackage: "Choose this pack",
    close: "Close",
    
    // Projects
    libraryDesc: "High-performance library of your AI creations",
    viewAll: "View All",
    landscape: "Landscape",
    portrait: "Portrait",
    merge: "Merge",
    cancel: "Cancel",
    loadingLibrary: "Loading your library...",
    emptyLibrary: "Library Empty",
    emptyLibraryDesc: "Your future creations will be automatically archived here.",
    createFirstVideo: "Create my first video",
    viewAllText: "View all",
    hideText: "Hide",
    viewDownload: "View / Download",
    mergeSequences: "Merge Sequences",
    organizeOrder: "Organize the order of your",
    videos: "videos",
    untitled: "Untitled",
    startMerge: "Start Merge",
    merging: "Merging",
    fullPrompt: "Full Prompt",
    mergeMode: "Merge Mode",
    mergeInstructions: "Select your videos by checking the boxes to start merging.",
    understood: "Understood",
    
    // CreateVideo
    welcomeStudio: "Welcome to the Creative Studio. 👋 \n\nI am ready to bring your ideas to life. Describe your concept, send a reference photo if you wish, and I will generate your video.",
    studioEngine: "Studio Creative Engine",
    optimizedBy: "Optimized by VEO3",
    clearHistory: "Clear History",
    confirm: "Confirm",
    save: "Save",
    generateSequel: "Generate Sequel",
    mergeOrder: "Merge Order:",
    scene: "Scene",
    selectTwoVideos: "Select at least 2 videos",
    landscapeRatio: "Landscape (16:9)",
    portraitRatio: "Portrait (9:16)",
    optimizing: "Optimizing...",
    improvePrompt: "Improve Prompt",
    highFidelity: "8s High Fidelity",
    processingImage: "Processing image...",
    explainVision: "Explain your vision...",
    propelProjects: "Boost your projects",
    limitlessCreativity: "More tokens for limitless creativity",
    recommended: "Recommended",
    choose: "Choose",
    clearHistoryTitle: "Clear History?",
    clearHistoryConfirm: "Do you really want to delete the chat history?",
    clearHistoryNote: "Note: This chat is stored locally and is not visible on any other device.",
    delete: "Delete",
    cv_sequel_prefix: "Video sequel: ",
    cv_merge_title: "🎬 **Sequence Merge**\n\nOrganize your scenes before final merge.",
    cv_merge_canceled: "Merge canceled.",
    cv_merge_confirmed: "Merge confirmed. Processing...",
    cv_merge_prep: "Preparing merge of {count} videos... (this may take time)",
    cv_finalizing: "Finalizing...",
    cv_merge_success: "Merge complete! Here is the result of {count} videos.{saved}",
    cv_saved_project: " (Saved in your projects)",
    cv_merge_error_res: "An error occurred while merging videos. This operation can be resource-intensive.",
    cv_merge_failed: "Merge failed.",
    cv_invalid_format: "Invalid format. JPG only.",
    cv_upload_error: "Image upload error.",
    cv_optimize_title: "⚡ **Prompt Optimization**\n\n📝 **Original:** {original}\n\n✨ **Improved:** {improved}\n\n(Input field updated)",
    cv_tokens_insufficient: "⚠️ Insufficient tokens (10 required for generation).",
    cv_confirm_gen: "Do you really want to generate video for this prompt: \"{prompt}\"?\n\nGeneration cost: 10 tokens.",
    cv_conf_received: "Confirmation received. Generation in progress...",
    cv_success_gen: "Operation completed successfully. Here is your creation.",
    cv_critical_error: "A critical error occurred during generation. Please ensure your invite complies with the following conditions: no violent, sexual, hateful content, no images of children, or any other sensitive topics. Try rewriting your invite to avoid these themes.",
    cv_gen_canceled: "Generation canceled.",
    cv_offer_error: "Offer error.",

    // AdGenerator Chat
    ad_welcome: "Hello! I am your video advertising expert. (08 seconds for now) 👋\n\nTo start, what is the name of the product you want to highlight?",
    ad_bg_timeout: "Processing took too long or failed.",
    ad_bg_complete: "Generation completed in background.",
    ad_video_recovered: "Here is your video (recovered):",
    ad_offer_error: "Error loading offers.",
    ad_step0_resp: "Noted. What emotion or desire do you want to arouse in your audience? (e.g., Luxury, Speed, Comfort...)",
    ad_step1_resp: "Very well. What are the key points or main features to highlight?",
    ad_step2_resp: "Perfect. Please now upload an image of your product by clicking the image icon below.",
    ad_step3_error: "I need an image to continue. Use the 🖼️ icon to the left of the text field.",
    ad_step4_resp: "Noted. In which language do you want the advertisement?",
    ad_format_ask: "Which format do you want? (Portrait for TikTok/Reels, Landscape for YouTube/Web)",
    ad_format_portrait: "Portrait Format (9:16)",
    ad_format_landscape: "Landscape Format (16:9)",
    ad_analyzing: "Analyzing... I am generating optimized advertising concepts for your product.",
    ad_unspecified: "Unspecified",
    ad_skip_price: "Skip price",
    ad_follow_steps: "Please follow the conversation steps.",
    ad_img_sent: "Image sent",
    ad_img_received: "Image received! What is the price of the product (or a price range)?",
    ad_analysis_done: "Analysis complete! Here are 5 advertising concepts. Click on the one you prefer to generate the video.",
    ad_analysis_error: "An error occurred during analysis.",
    ad_tokens_insufficient: "⚠️ Insufficient tokens (10 required).",
    ad_confirm_concept: "You chose the concept: \"{suggestion}\"\n\nDo you confirm generation? (Cost: 10 tokens)",
    ad_concept_validated: "Concept validated. Starting production...",
    ad_downloading_img: "Excellent choice! Downloading image and starting production...",
    ad_img_ready: "Image ready. Video generation in progress...",
    ad_gen_success: "Video generated successfully!",
    ad_gen_another: "Do you wish to generate another advertisement?",
    ad_gen_error: "Error during video generation.",
    ad_gen_canceled: "Generation canceled.",
    
    // AdGenerator
    adGenTitle: "Ad Generator",
    marketingAssistant: "AI Marketing Assistant",
    clearConversation: "Clear conversation",
    confirmTokens: "Confirm (10 tokens)",
    newAd: "New Ad",
    selectConcept: "Select a concept:",
    restart: "Restart",
    restartZero: "Restart from scratch",
    uploadImage: "Upload an image...",
    writeResponse: "Write your response...",
    skip: "Skip",
    propelAds: "Boost your ads with our packs",
    
    // Auth & Footer
    accessExcellence: "Access technological excellence. High-performance video creation studio.",
    reset: "Reset",
    email: "Email",
    sendLink: "Send Link",
    backLogin: "Back to Login",
    password: "Password",
    forgotPassword: "Forgot Password?",
    connecting: "Logging in...",
    noAccount: "No account yet?",
    joinElite: "Join the creative elite. Professional videos within your imagination's reach.",
    createAccount: "Create Account",
    fullName: "Full Name",
    confirmEmail: "Confirm Email",
    registering: "Registering...",
    registerFree: "Sign up for free",
    alreadyAccount: "Already have an account?",
    footerDesc: "The ultimate solution for generating advertising and viral videos using artificial intelligence.",
    product: "Product",
    pricing: "Pricing",
    features: "Features",
    showcase: "Showcase",
    legal: "Legal",
    legalMentions: "Legal Mentions",
    privacyPolicy: "Privacy Policy",
    terms: "Terms",
    contact: "Contact",
    needHelp: "Need help?",
    rightsReserved: "All rights reserved."
  }
};